/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getVideoURLs = /* GraphQL */ `
  query GetVideoURLs($id: ID!) {
    getVideoURLs(id: $id) {
      id
      guid
      srcvideo
      MP4
      CMAF
      HLS
      DASH
      MSS
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listVideoURLs = /* GraphQL */ `
  query ListVideoURLs(
    $filter: ModelVideoURLsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoURLs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        guid
        srcvideo
        MP4
        CMAF
        HLS
        DASH
        MSS
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncVideoURLs = /* GraphQL */ `
  query SyncVideoURLs(
    $filter: ModelVideoURLsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncVideoURLs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        guid
        srcvideo
        MP4
        CMAF
        HLS
        DASH
        MSS
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getVideo = /* GraphQL */ `
  query GetVideo($id: ID!) {
    getVideo(id: $id) {
      id
      title
      description
      url
      poster
      duration
      date
      category {
        id
        name
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      teacher {
        id
        name
        image
        bio
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tags {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      categoryVideosId
      teacherVideosId
      __typename
    }
  }
`;
export const listVideos = /* GraphQL */ `
  query ListVideos(
    $filter: ModelVideoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncVideos = /* GraphQL */ `
  query SyncVideos(
    $filter: ModelVideoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncVideos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      name
      description
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCategories = /* GraphQL */ `
  query SyncCategories(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacher = /* GraphQL */ `
  query GetTeacher($id: ID!) {
    getTeacher(id: $id) {
      id
      name
      image
      bio
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTeachers = /* GraphQL */ `
  query ListTeachers(
    $filter: ModelTeacherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeachers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        image
        bio
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeachers = /* GraphQL */ `
  query SyncTeachers(
    $filter: ModelTeacherFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeachers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        image
        bio
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTag = /* GraphQL */ `
  query GetTag($id: ID!) {
    getTag(id: $id) {
      id
      name
      video {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTags = /* GraphQL */ `
  query ListTags(
    $filter: ModelTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTags = /* GraphQL */ `
  query SyncTags(
    $filter: ModelTagFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTags(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUserData = /* GraphQL */ `
  query GetUserData($id: ID!) {
    getUserData(id: $id) {
      id
      cognitoSub
      favorites
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listUserData = /* GraphQL */ `
  query ListUserData(
    $filter: ModelUserDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserData(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cognitoSub
        favorites
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserData = /* GraphQL */ `
  query SyncUserData(
    $filter: ModelUserDataFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserData(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        cognitoSub
        favorites
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCourse = /* GraphQL */ `
  query GetCourse($id: ID!) {
    getCourse(id: $id) {
      id
      title
      description
      image
      modules {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCourses = /* GraphQL */ `
  query ListCourses(
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        image
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCourses = /* GraphQL */ `
  query SyncCourses(
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCourses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        image
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCourseModule = /* GraphQL */ `
  query GetCourseModule($id: ID!) {
    getCourseModule(id: $id) {
      id
      courseID
      moduleID
      course {
        id
        title
        description
        image
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCourseModules = /* GraphQL */ `
  query ListCourseModules(
    $filter: ModelCourseModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourseModules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        courseID
        moduleID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCourseModules = /* GraphQL */ `
  query SyncCourseModules(
    $filter: ModelCourseModuleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCourseModules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        courseID
        moduleID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const courseModulesByCourseID = /* GraphQL */ `
  query CourseModulesByCourseID(
    $courseID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCourseModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    courseModulesByCourseID(
      courseID: $courseID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseID
        moduleID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const courseModulesByModuleID = /* GraphQL */ `
  query CourseModulesByModuleID(
    $moduleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCourseModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    courseModulesByModuleID(
      moduleID: $moduleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseID
        moduleID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getModule = /* GraphQL */ `
  query GetModule($id: ID!) {
    getModule(id: $id) {
      id
      title
      description
      courses {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listModules = /* GraphQL */ `
  query ListModules(
    $filter: ModelModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncModules = /* GraphQL */ `
  query SyncModules(
    $filter: ModelModuleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncModules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getModuleLesson = /* GraphQL */ `
  query GetModuleLesson($id: ID!) {
    getModuleLesson(id: $id) {
      id
      moduleID
      lessonID
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listModuleLessons = /* GraphQL */ `
  query ListModuleLessons(
    $filter: ModelModuleLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModuleLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        moduleID
        lessonID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncModuleLessons = /* GraphQL */ `
  query SyncModuleLessons(
    $filter: ModelModuleLessonFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncModuleLessons(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        moduleID
        lessonID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const moduleLessonsByModuleID = /* GraphQL */ `
  query ModuleLessonsByModuleID(
    $moduleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelModuleLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    moduleLessonsByModuleID(
      moduleID: $moduleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        moduleID
        lessonID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const moduleLessonsByLessonID = /* GraphQL */ `
  query ModuleLessonsByLessonID(
    $lessonID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelModuleLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    moduleLessonsByLessonID(
      lessonID: $lessonID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        moduleID
        lessonID
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLesson = /* GraphQL */ `
  query GetLesson($id: ID!) {
    getLesson(id: $id) {
      id
      title
      content
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      videoID
      modules {
        nextToken
        startedAt
        __typename
      }
      faqItems {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      videoLessonsId
      __typename
    }
  }
`;
export const listLessons = /* GraphQL */ `
  query ListLessons(
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncLessons = /* GraphQL */ `
  query SyncLessons(
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLessons(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getToolCategory = /* GraphQL */ `
  query GetToolCategory($id: ID!) {
    getToolCategory(id: $id) {
      id
      title
      description
      tools {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listToolCategories = /* GraphQL */ `
  query ListToolCategories(
    $filter: ModelToolCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listToolCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncToolCategories = /* GraphQL */ `
  query SyncToolCategories(
    $filter: ModelToolCategoryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncToolCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTool = /* GraphQL */ `
  query GetTool($id: ID!) {
    getTool(id: $id) {
      id
      title
      url
      toolCategoryID
      toolCategory {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      toolCategoryToolsId
      __typename
    }
  }
`;
export const listTools = /* GraphQL */ `
  query ListTools(
    $filter: ModelToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTools(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        url
        toolCategoryID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        toolCategoryToolsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTools = /* GraphQL */ `
  query SyncTools(
    $filter: ModelToolFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTools(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        url
        toolCategoryID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        toolCategoryToolsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const toolsByToolCategoryID = /* GraphQL */ `
  query ToolsByToolCategoryID(
    $toolCategoryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    toolsByToolCategoryID(
      toolCategoryID: $toolCategoryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        url
        toolCategoryID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        toolCategoryToolsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUserProgress = /* GraphQL */ `
  query GetUserProgress($id: ID!) {
    getUserProgress(id: $id) {
      id
      userID
      courseID
      moduleProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listUserProgresses = /* GraphQL */ `
  query ListUserProgresses(
    $filter: ModelUserProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProgresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        courseID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserProgresses = /* GraphQL */ `
  query SyncUserProgresses(
    $filter: ModelUserProgressFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userID
        courseID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const userProgressesByUserIDAndCourseID = /* GraphQL */ `
  query UserProgressesByUserIDAndCourseID(
    $userID: ID!
    $courseID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userProgressesByUserIDAndCourseID(
      userID: $userID
      courseID: $courseID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        courseID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getModuleProgress = /* GraphQL */ `
  query GetModuleProgress($id: ID!) {
    getModuleProgress(id: $id) {
      id
      userID
      userProgressID
      moduleID
      userProgress {
        id
        userID
        courseID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lessonProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listModuleProgresses = /* GraphQL */ `
  query ListModuleProgresses(
    $filter: ModelModuleProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModuleProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        userProgressID
        moduleID
        progressPercentage
        completed
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncModuleProgresses = /* GraphQL */ `
  query SyncModuleProgresses(
    $filter: ModelModuleProgressFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncModuleProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userID
        userProgressID
        moduleID
        progressPercentage
        completed
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const moduleProgressesByUserProgressID = /* GraphQL */ `
  query ModuleProgressesByUserProgressID(
    $userProgressID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelModuleProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    moduleProgressesByUserProgressID(
      userProgressID: $userProgressID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        userProgressID
        moduleID
        progressPercentage
        completed
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLessonProgress = /* GraphQL */ `
  query GetLessonProgress($id: ID!) {
    getLessonProgress(id: $id) {
      id
      userID
      lessonID
      moduleID
      moduleProgressID
      moduleProgress {
        id
        userID
        userProgressID
        moduleID
        progressPercentage
        completed
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lastViewedAt
      lastWatchedPosition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listLessonProgresses = /* GraphQL */ `
  query ListLessonProgresses(
    $filter: ModelLessonProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        lessonID
        moduleID
        moduleProgressID
        progressPercentage
        completed
        lastViewedAt
        lastWatchedPosition
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncLessonProgresses = /* GraphQL */ `
  query SyncLessonProgresses(
    $filter: ModelLessonProgressFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLessonProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userID
        lessonID
        moduleID
        moduleProgressID
        progressPercentage
        completed
        lastViewedAt
        lastWatchedPosition
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const lessonProgressesByModuleProgressID = /* GraphQL */ `
  query LessonProgressesByModuleProgressID(
    $moduleProgressID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLessonProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonProgressesByModuleProgressID(
      moduleProgressID: $moduleProgressID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        lessonID
        moduleID
        moduleProgressID
        progressPercentage
        completed
        lastViewedAt
        lastWatchedPosition
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getFAQItem = /* GraphQL */ `
  query GetFAQItem($id: ID!) {
    getFAQItem(id: $id) {
      id
      question
      answer
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listFAQItems = /* GraphQL */ `
  query ListFAQItems(
    $filter: ModelFAQItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFAQItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        question
        answer
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncFAQItems = /* GraphQL */ `
  query SyncFAQItems(
    $filter: ModelFAQItemFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFAQItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        question
        answer
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLessonFAQItem = /* GraphQL */ `
  query GetLessonFAQItem($id: ID!) {
    getLessonFAQItem(id: $id) {
      id
      lessonID
      faqItemID
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      faqItem {
        id
        question
        answer
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listLessonFAQItems = /* GraphQL */ `
  query ListLessonFAQItems(
    $filter: ModelLessonFAQItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonFAQItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lessonID
        faqItemID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncLessonFAQItems = /* GraphQL */ `
  query SyncLessonFAQItems(
    $filter: ModelLessonFAQItemFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLessonFAQItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        lessonID
        faqItemID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const lessonFAQItemsByLessonIDAndFaqItemID = /* GraphQL */ `
  query LessonFAQItemsByLessonIDAndFaqItemID(
    $lessonID: ID!
    $faqItemID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFAQItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonFAQItemsByLessonIDAndFaqItemID(
      lessonID: $lessonID
      faqItemID: $faqItemID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        faqItemID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const lessonFAQItemsByFaqItemIDAndLessonID = /* GraphQL */ `
  query LessonFAQItemsByFaqItemIDAndLessonID(
    $faqItemID: ID!
    $lessonID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFAQItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonFAQItemsByFaqItemIDAndLessonID(
      faqItemID: $faqItemID
      lessonID: $lessonID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        faqItemID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getVideoTags = /* GraphQL */ `
  query GetVideoTags($id: ID!) {
    getVideoTags(id: $id) {
      id
      videoId
      tagId
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      tag {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listVideoTags = /* GraphQL */ `
  query ListVideoTags(
    $filter: ModelVideoTagsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        videoId
        tagId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncVideoTags = /* GraphQL */ `
  query SyncVideoTags(
    $filter: ModelVideoTagsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncVideoTags(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        videoId
        tagId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const videoTagsByVideoId = /* GraphQL */ `
  query VideoTagsByVideoId(
    $videoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVideoTagsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videoTagsByVideoId(
      videoId: $videoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoId
        tagId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const videoTagsByTagId = /* GraphQL */ `
  query VideoTagsByTagId(
    $tagId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVideoTagsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videoTagsByTagId(
      tagId: $tagId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoId
        tagId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
